import React from 'react';
import PrototypeOne from '@blocks/custom-block/prototype-1';
import CookiebotManager from '@blocks/custom-block/cookiebot-manager';
import CSISearch from '@blocks/custom-block/csi-search';
import JobVacancies from '../../../../static-components/job-vacancies/job-vacancies';
import { CustomBlockProps } from './custom-block-handler.types';
import StyledHoneyCombContainerBlock from '@blocks/honeycomb-block/honeycomb-container';
import { useDataContext } from '../../context/page-context-provider';

const CustomBlockHandler: React.FC<CustomBlockProps> = ({
  content: { customBlockId, anchorId },
}) => {
  const { pageContext } = useDataContext();

  if (customBlockId) {
    switch (customBlockId) {
      case 'prototype-1':
        return <PrototypeOne anchorId={anchorId} />;
      case 'csi-search':
        return <CSISearch />;
      case 'job-vacancies':
        return <JobVacancies />;
      case 'honeycomb':
        return (
          <StyledHoneyCombContainerBlock
            className="honeycombclass"
            pageContext={pageContext}
            anchorId={anchorId || ''}
          />
        );
      case 'cookiebot-manager':
        return <CookiebotManager />;
      default:
        console.warn(
          'CustomBlockHandler received unrecognized customBlockId:',
          customBlockId
        );
        return null;
    }
  } else {
    console.warn(
      'CustomBlockHandler received non-truthy customBlockId:',
      customBlockId
    );
    return null;
  }
};

export default CustomBlockHandler;
